import React, { useState, useEffect } from 'react';
import Header from './Header';
import PromotionService from '../services/promotion.service';
import ProductsService from '../services/product.service';
import useApi from '../hooks/useApi';
import useAuth from '../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { getGiftValidityDateValue } from '../utils/giftValidity';


const Treatment = () => {
    const { t } = useTranslation('treatment');
    const api = useApi();
    const { auth } = useAuth();
    const [showAddressField, setShowAddressField] = useState(false);
    const [isCompactOfferSelect, setIsCompactOfferSelect] = useState(
        () => typeof window !== 'undefined' && window.innerWidth <= 786
    );
    const [products, setProducts] = useState([]);
    const [treatmentDetails, setTreatmentDetails] = useState({
        product: '',
        duration: '30min',
        validity: '2 years',
        deliveryAddress: '',
        promoCode: '',
        client_id: auth?.user?.id,
        amount: '',
    });

    const handleToggle = () => {
        setShowAddressField(!showAddressField);
    };

    useEffect(() => {
        const handleResize = () => setIsCompactOfferSelect(window.innerWidth <= 786);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'product') {
            const selectedProduct = products.find((product) => product.id.toString() === value);

            console.log({ selectedProduct })

            setTreatmentDetails((prevDetails) => ({
                ...prevDetails,
                [name]: value,
                amount: selectedProduct ? selectedProduct.price : '',
            }));
        } else {
            setTreatmentDetails((prevDetails) => ({
                ...prevDetails,
                [name]: value,
            }));
        }
    };


    const fetchProducts = async () => {
        try {
            const response = await ProductsService.index({ with: 'category', is_active: 1 }, api);
            console.log({ response })
            setProducts(response);
        } catch (error) {

        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // Generate the promo code dynamically
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let promoCode = '';
        for (let i = 0; i < 10; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            promoCode += characters.charAt(randomIndex);
        }
        setTreatmentDetails((prevDetails) => ({
            ...prevDetails,
            promoCode,
        }));

        const validityDate = new Date();
        validityDate.setFullYear(validityDate.getFullYear() + 2);
        const validityDateValue = getGiftValidityDateValue(validityDate);

        const payload = {
            name: 'Treatment Purchase',
            code: promoCode,
            date_creation: new Date().toISOString().split('T')[0],
            date_validity: validityDateValue,
            type: 'FLATT_OFF',
            amount: treatmentDetails.amount,
            assigned_to: 'All',
            total_usage: 1,
            usage_per_customer: 1,
            notifyClients: false,
            is_active: 1,
            client_id: treatmentDetails.client_id,
            product_id: treatmentDetails.product,
        };

        try {
            await PromotionService.store(payload, api);
        } catch (error) {

        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const formatOfferLabel = (label) => {
        if (!isCompactOfferSelect || label.length <= 42) return label;
        return `${label.slice(0, 39)}...`;
    };

    return (
        <>
            <Header />

            <div className="container buy-container gift-page">
                <h2>{t('treatment:acheter')}</h2>
                <form onSubmit={handleFormSubmit}>
                    <div className="form-group">
                        <label htmlFor="massage">{t('treatment:acheter_de')}</label>
                        <select
                            id="massage"
                            name="product"
                            className="form-control buy-select-control"
                            value={treatmentDetails.product}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="" disabled>
                                {t('treatment:seletionner')}
                            </option>
                            {products.length > 0 ? (
                                products.map((product) => (
                                    <option key={product.id} value={product.id}>
                                        {formatOfferLabel(`${product.category?.title} / ${product.name}`)}
                                    </option>
                                ))
                            ) : (
                                <option value="" disabled>
                                    {t('treatment:aucun')}
                                </option>
                            )}
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="price">{t('treatment:prix')}</label>
                        <input
                            type="text"
                            id="price"
                            name="amount"
                            className="form-control"
                            value={treatmentDetails.amount}
                            onChange={handleInputChange}
                            readOnly
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="validity">{t('treatment:validity')}</label>
                        <select
                            id="validity"
                            name="validity"
                            className="form-control"
                            value={treatmentDetails.validity}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="2 years">2 {t('treatment:ans')}</option>
                        </select>
                    </div>
                    <div
                        className="giftCard"
                        style={{ borderColor: showAddressField ? '#393D44' : '' }}
                    >
                        <div
                            className="text-wrapper"
                            style={{ color: showAddressField ? '#393D44' : '' }}
                        >
                            {t('treatment:carte')}
                        </div>
                        <label className="switch">
                            <input
                                type="checkbox"
                                id="toggle"
                                onChange={handleToggle}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>
                    {showAddressField && (
                        <div className="form-group">
                            <label htmlFor="deliveryAddress">{t('treatment:adresse')}</label>
                            <input
                                type="text"
                                id="deliveryAddress"
                                name="deliveryAddress"
                                className="form-control"
                                placeholder="Adresse"
                                value={treatmentDetails.deliveryAddress}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    )}
                    <button type="submit" className="btn btn-primary gift-btn">
                        {t('treatment:continuer')}
                    </button>
                </form>
            </div>
        </>
    );
};

export default Treatment;
